"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWidgetReadyStatus = exports.setWidgetLoadedStatus = exports.setInstanceId = exports.SET_WIDGET_READY_STATUS = exports.SET_WIDGET_LOADED_STATUS = exports.SET_INSTANCE_ID = void 0;
var SET_INSTANCE_ID = 'SET_INSTANCE_ID';
exports.SET_INSTANCE_ID = SET_INSTANCE_ID;
var SET_WIDGET_LOADED_STATUS = 'SET_WIDGET_LOADED_STATUS';
exports.SET_WIDGET_LOADED_STATUS = SET_WIDGET_LOADED_STATUS;
var SET_WIDGET_READY_STATUS = 'SET_WIDGET_READY_STATUS';
exports.SET_WIDGET_READY_STATUS = SET_WIDGET_READY_STATUS;
var setInstanceId = function setInstanceId(instanceId) {
  return {
    type: SET_INSTANCE_ID,
    payload: {
      instanceId: instanceId
    }
  };
};
exports.setInstanceId = setInstanceId;
var setWidgetLoadedStatus = function setWidgetLoadedStatus(isWidgetLoaded) {
  return {
    type: SET_WIDGET_LOADED_STATUS,
    payload: {
      isWidgetLoaded: isWidgetLoaded
    }
  };
};
exports.setWidgetLoadedStatus = setWidgetLoadedStatus;
var setWidgetReadyStatus = function setWidgetReadyStatus(isWidgetReady) {
  return {
    type: SET_WIDGET_READY_STATUS,
    payload: {
      isWidgetReady: isWidgetReady
    }
  };
};
exports.setWidgetReadyStatus = setWidgetReadyStatus;